import { Vue, Component, Prop } from 'vue-property-decorator'
import type { IApprovalForm } from '../../types'

@Component
export default class ApprovalDataProps extends Vue {
  @Prop({ required: false, default: false }) checkoutNeedsApproval!: boolean;

  @Prop({ required: false, default: () => ({}) }) approvalForm!: IApprovalForm;
}
